export default __webpack_public_path__ + "static/media/Rectangle 372.06fe9395.png";